import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const Timer = ({ timeLeft, totalTime, onTimeUp }) => {
	const { t } = useTranslation();
	const [percentage, setPercentage] = useState(100);

	useEffect(() => {
		if (totalTime > 0) {
			// Avoid division by zero if totalTime is not ready
			setPercentage((timeLeft / totalTime) * 100);
		} else {
			setPercentage(100);
		}

		if (timeLeft === 0 && onTimeUp) {
			onTimeUp();
		}
	}, [timeLeft, totalTime, onTimeUp]);

	const getColorClass = () => {
		if (percentage > 66) return 'bg-success-500';
		if (percentage > 33) return 'bg-warning-500';
		return 'bg-danger-500';
	};

	return (
		<div className='w-full mb-4'>
			<div className='flex justify-between mb-1'>
				<span className='text-sm font-medium'>{t('timerView.label')}</span>
				<span className='text-sm font-medium'>{t('timerView.timeLeft', { count: timeLeft })}</span>
			</div>
			<div className='timer-bar'>
				{' '}
				<div className={`timer-progress ${getColorClass()}`} style={{ width: `${percentage}%` }}></div>
			</div>
		</div>
	);
};

export default Timer;
